var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 51C36.85 51 37.5625 50.7125 38.1375 50.1375C38.7125 49.5625 39 48.85 39 48C39 47.15 38.7125 46.4375 38.1375 45.8625C37.5625 45.2875 36.85 45 36 45C35.15 45 34.4375 45.2875 33.8625 45.8625C33.2875 46.4375 33 47.15 33 48C33 48.85 33.2875 49.5625 33.8625 50.1375C34.4375 50.7125 35.15 51 36 51ZM33 39H39V21H33V39ZM24.75 63L9 47.25V24.75L24.75 9H47.25L63 24.75V47.25L47.25 63H24.75ZM27.3 57H44.7L57 44.7V27.3L44.7 15H27.3L15 27.3V44.7L27.3 57Z",
    fill: "#0094FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/ErrorIcon.537a349e7f59c570f3c21edf01b6a211.svg";
export { ForwardRef as ReactComponent };